import { Ticket, QrCode, BarChart3, Users } from "lucide-react";

const FEATURES = [
  { icon: Ticket, title: "Sell tickets in minutes", desc: "Tiers, M-Pesa, instant confirmations." },
  { icon: QrCode, title: "QR check-in at the gate", desc: "Scan, admit, and track arrivals live." },
  { icon: BarChart3, title: "Know your numbers", desc: "Revenue, attendance & conversion at a glance." },
  { icon: Users, title: "Run your team", desc: "Virtual offices, rooms, tasks & vendor bids." },
];

/**
 * Marketing/“catchy” panel shown beside auth forms.
 * On large screens it sits to the right; on small screens it stacks below the form.
 */
const AuthSidePanel = () => (
  <div className="relative h-full min-h-[42vh] lg:min-h-screen overflow-hidden bg-gradient-to-br from-indigo-600 via-purple-600 to-pink-500 text-white flex flex-col justify-center p-10 lg:p-14">
    {/* soft decorative blobs */}
    <div className="absolute -top-20 -right-20 w-72 h-72 bg-white/10 rounded-full blur-2xl" />
    <div className="absolute -bottom-24 -left-16 w-80 h-80 bg-white/10 rounded-full blur-3xl" />

    <div className="relative z-10 max-w-md mx-auto lg:mx-0">
      <p className="uppercase tracking-[0.3em] text-white/70 text-xs mb-3">EventSawa</p>
      <h2 className="text-3xl lg:text-4xl font-extrabold leading-tight">
        Everything you need to run world-class events.
      </h2>
      <p className="mt-3 text-white/80">
        From ticket sales and seating to check-in, analytics and your event team — one platform.
      </p>

      <div className="mt-8 space-y-5">
        {FEATURES.map(({ icon: Icon, title, desc }) => (
          <div key={title} className="flex items-start gap-3">
            <div className="h-10 w-10 rounded-xl bg-white/15 backdrop-blur flex items-center justify-center flex-shrink-0">
              <Icon className="w-5 h-5" />
            </div>
            <div>
              <p className="font-semibold">{title}</p>
              <p className="text-sm text-white/75">{desc}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default AuthSidePanel;
